<script>

import Service from '../../../services/equipment-operation';
import FiscalNotificationService from '../../../services/fiscal-notification';

import Card from 'primevue/card';
import Calendar from 'primevue/calendar';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';
import GenericCustomMasterDataAutocompleteV2 from '../../generic/GenericCustomMasterDataAutocompleteV2.vue'
//import GenericCustomAutocompleteV2 from '../../generic/GenericCustomAutocompleteV2.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
    props: ['executeCalculation', 'movementCalculation'],
    components: {
        Card, Calendar, RadioButton, InputNumber, Dropdown, Button,
        GenericCustomMasterDataAutocompleteV2 //, GenericCustomAutocompleteV2
    },
    data(){
        return {
            submitted: false,
            tankSelected: null,
            isGas: false,
            managementType: "NORMAL",
            managementTypesOptions: ['NORMAL','PROMISCOUS'],
            data: {
                tankCode: null,
                calculationDate: null,
                inService: true,
                productId: null,
                density15: null,
                gasPressure: null,
                gasTemperature: null,
                molecularWeight: null,
                measureType: 'Full',
                productLevel: null,
                feetPosition: 'D',
                calibrationTemperature: null
            },
            movementData: {
                movementType: 'I'
            },
            footPositionOptions: [
                {
                    value: 'D',
                },
                {
                    value: 'U'
                }
            ],
            movementTypes: [
                {
                    value: 'I'
                },
                {
                    value: 'O'
                },
            ],
            idScheduledOperation: null,
            isPartialMeasure: false
        }
    },
    validations(){
        return {
            data: {
                tankCode: {required},
                calculationDate: {required},
                productId: {required},
                gasPressure: {customValidation: value => !this.isGas || value},
                gasTemperature: {customValidation: value => !this.isGas || value},
                molecularWeight: {customValidation: value => !this.isGas || value},
                productLevel: {required},
                environmentTemperature: {customValidation: value => this.isGas || value},
                temperature: {required},
                density15: {required},
                waterLevel: {customValidation: value => this.isGas || (value === 0) || value},
                simulationMovedWeight: { } 
            }
        }
    },
    methods: {
        populateInput(data){
            let input = {
                tankCode: data.tankCode,
                calculationDate: data.operationDate,
                inService: true,
                productId: data.idRegistryProduct,
                density15: data.density15,
                measureType: 'Full',
                productLevel: data.productLevel,
                environmentTemperature: data.environmentTemperature,
                gasPressure: data.gasPressure,
                gasTemperature: data.gasTemperature,
                molecularWeight: data.molecularWeight,
                temperature: data.temperature,
                feetPosition: this.data.feetPosition,
                waterLevel: data.waterLevel,
                // calibrationTemperature: this.data.calibrationTemperature,
                managementType: data.managementType,
                idRegistryOperationType: data.idRegistryOperationType,
                forceManagementType: false,
                isSender: true
            }

            if(data.registryOperationType == 'TRV' || data.registryOperationType == 'SPZ'){
                if(data.otherTank != null && data.tankCode != data.mainTank ){
                    input.isSender = false;
                }
            }

            this.managementType = data.managementType == 'Promiscous' ? 'PROMISCOUS' : 'NORMAL'

            if(this.data.tankCode == data.tankCode){
                input.calibrationTemperature = this.data.calibrationTemperature;
            }

            this.idScheduledOperation = data.idOperativePlan;
            this.isPartialMeasure = data.isPartialMeasure;
            this.data = input;

            if(this.idScheduledOperation && this.isPartialMeasure){
                this.getAutocompletePartialMeasureValues();
            }
            //this.$refs.tankAC.callOnItemSelect();
        },
        onTankSelected(event){
            if(event){
                this.tankSelected = event.value;
                if(event.extraData){
                    this.data.calibrationTemperature = event.extraData.calibrationTemperature;
                    this.data.feetPosition = event.extraData.feetPosition;
                    this.data.roofWeight = event.extraData.roofWeight;
                }
            }
        },
        onFeetPositionSelect(event){
            if(this.tankSelected != null){
                if(event.value != this.tankSelected.feetPosition && (this.tankSelected.feetPosition == 'D' || this.tankSelected.feetPosition == 'H')){
                    this.$confirm.require({
                        message: this.$t('calculatorInsertData.wrongFeetMessage', {tankCode: this.tankSelected.code, feetPosition: this.$t('calculatorTankDevelopment.footPosition' + this.tankSelected.feetPosition)}),
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: this.$t('yes'),
                        rejectLabel: this.$t('no'),
                        accept: () => {
                            
                        },
                        reject: () => {
                            this.data.feetPosition = this.tankSelected.feetPosition;
                            //callback to execute when user rejects the action
                            this.$confirm.close();
                        }
                    });
                }
            }
        },
        submitCalculate(valid){
            this.submitted = true;

            if (!valid){
                return;
            }

            this.submitted = false;
            this.executeCalculation(this.data, this.movementData);

        },
        getInputData(){
            return this.data; 
        },
        getManagementType(){
            return this.managementType;  
        },
        getMovementData(){
            return this.movementData; 
        },
        loadLastOperation(){
            if(this.movementCalculation){
                if(this.data.tankCode && this.data.calculationDate){
                    this.$emit('loadPrevOperation', this.data);
                }
            }
        },
        onProductSelected({extraData}){
            this.isGas = extraData.isGas;
        },
        importFromPI(){
            this.$store.dispatch("generic/setLoading", true);
            Service.importFromPI({date: this.data.calculationDate, tank: this.data.tankCode}, ({success, data}) =>{
                this.$store.dispatch("generic/setLoading", false);
                if(success){
                data.reverse().forEach(({items}) => {
                    const [{description, value}] = items;
                    const key = {
                    'EnvironmentTemperature': 'environmentTemperature',
                    'Level': 'productLevel',
                    'Temperature': 'temperature',
                    //'Density': 'density15',
                    'Pressure': 'gasPressure',
                    'Gas Temperature': 'gasTemperature'
                    }?.[description];

                    key && (this.data[key] = value);
                })
                } else {
                    this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        getAutocompletePartialMeasureValues(){
            if(this.isPartialMeasure && this.idScheduledOperation){
                let body = {
                    tankCode: this.data.tankCode,
                    idScheduledOperation: this.idScheduledOperation
                }
                FiscalNotificationService.getAutocompletePartialMeasureValues(body, (response) => {
                    if(response.success){
                        if(response.data.productLevel){
                            this.data.productLevel = response.data.productLevel;
                        }
                        if(response.data.temperature){
                            this.data.temperature = response.data.temperature;
                        }
                        if(response.data.operationDate){
                            this.data.calculationDate = new Date(Utils.dateToCurrentTimeZone(response.data.operationDate));
                        }
                    }
                })
            }
        },
        getAutocompleteTankCalculationValues(){
            if(!this.isPartialMeasure && this.data.tankCode && this.data.calculationDate && this.data.productId && this.idScheduledOperation){
                let body = {
                    tankCode: this.data.tankCode,
                    idScheduledOperation: this.idScheduledOperation,
                    operationDate: Utils.formatDateForAPIWithTime(this.data.calculationDate),
                    idProduct: this.data.productId
                }
                Service.getAutocompleteTankCalculationValues(body, (response) => {
                    if(response.success){
                        // if(response.data.density15){
                            this.data.density15 = response.data.density15;
                        // }
                        // if(response.data.environmentTemperature){
                            this.data.environmentTemperature = response.data.environmentTemperature;
                        // }
                        // if(response.data.molecularWeight){
                            this.data.molecularWeight = response.data.molecularWeight;
                        // }
                        // if(response.data.waterLevel){
                            this.data.waterLevel = response.data.waterLevel;
                        // }
                    }
                })
            }
        },
        loadEnvironmentTemperature(){
            if(this.data.calculationDate){
                Service.getEnvironmentTemperature({date: this.data.calculationDate}, (response) => {
                    if(response.success){
                        this.data.environmentTemperature = response.data;
                    }else{
                        this.data.environmentTemperature = null;
                    }
                })
            }
        }
    },
    watch: {
        'data.tankCode'() {
            this.loadLastOperation();
            this.getAutocompleteTankCalculationValues();
        },
        'data.calculationDate'() {
            if(this.data.calculationDate){
                Utils.nullSAndMS(this.data.calculationDate)
            }
            this.loadEnvironmentTemperature();
            this.loadLastOperation();
            this.getAutocompleteTankCalculationValues();
        },
        'data.productId'(){
            this.getAutocompleteTankCalculationValues();
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },  
}
</script>

<template>

    <Card>
        <template #subtitle>
            {{$t('calculatorTankDevelopment.title')}}
        </template>
        <template #content>
            <div class="grid formgrid" >
                <!-- <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorInsertData.inService')}}</label>
                    <GenericBooleanDropdown
                      id="inService" 
                      v-model="data.inService" 
                      class="w-full p-inputtext-sm " />
                </div> -->
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.calculationDate.$invalid && submitted}">{{$t('calculatorInsertData.date_hour')}}</label>
                    <Calendar 
                        v-model="data.calculationDate"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="true" :hideOnDateTimeSelect="true"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        class="w-full p-inputtext-sm " />
                        
                        <div v-if="(v$.data.calculationDate.$invalid && submitted) || v$.data.calculationDate.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.calculationDate.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.productId.$invalid && submitted}">{{$t('calculatorInsertData.product')}}</label>
                    <GenericCustomMasterDataAutocompleteV2 
                        :changeFn="onProductSelected"
                        v-model="data.productId" 
                        name="products" 
                        api="masterdata/product-combo"
                        class="p-inputtext-sm"/>    
                        <div v-if="(v$.data.productId.$invalid && submitted) || v$.data.productId.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.productId.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>   
                </div>
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.tankCode.$invalid && submitted}">{{$t('calculatorInsertData.container')}}</label>
                        <GenericCustomMasterDataAutocompleteV2
                            ref="tankAC"
                            :changeFn="onTankSelected"
                            class="w-full p-inputtext-sm"
                            v-model="data.tankCode"
                            name="tank-management-tank-combo"
                            :format="{ label: 'code', value: 'code' }"
                            api="tank-management/tank-combo" />   
                        <div v-if="(v$.data.tankCode.$invalid && submitted) || v$.data.tankCode.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.tankCode.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>  
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.footPosition')}}</label>
                    <Dropdown class="w-full p-inputtext-sm" @change="onFeetPositionSelect" :placeholder="null" v-model="data.feetPosition" :options="footPositionOptions" optionValue="value">
                        <template #value="slotProps">
                        <div v-if="slotProps.value == 'D'">
                            <span>{{$t('calculatorTankDevelopment.footPositionD')}}</span>
                        </div>
                        <div v-else-if="slotProps.value == 'U'">
                            <span>{{$t('calculatorTankDevelopment.footPositionH')}}</span>
                        </div>
                        <div v-else>
                            <span class="p-dropdown-label">{{slotProps.value}}</span>
                        </div>
                    </template>
                        <template #option="slotProps">
                            <div v-if="slotProps.option.value == 'D'">
                                <span>{{$t('calculatorTankDevelopment.footPositionD')}}</span>
                            </div>
                            <div v-else-if="slotProps.option.value == 'U'">
                                <span>{{$t('calculatorTankDevelopment.footPositionH')}}</span>
                            </div>
                        </template>
                    </Dropdown>
                </div>
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.productLevel.$invalid && submitted}">{{$t('calculatorTankDevelopment.level')}}</label>
                    <InputNumber class="p-inputtext-sm w-full" id="level"  v-model="data.productLevel" :minFractionDigits="0" :maxFractionDigits="0"/>
                        <div v-if="(v$.data.productLevel.$invalid && submitted) || v$.data.productLevel.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.productLevel.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>
                <div class="col-12 lg:col-6 field-radio">
                    <label></label>
                    <div class="my-5">
                        <RadioButton value="Full" v-model="data.measureType" />
                        <label class="mx-1">{{$t('calculatorTankDevelopment.full')}}</label>
                        <RadioButton value="Empty" v-model="data.measureType" />
                        <label class="mx-1">{{$t('calculatorTankDevelopment.empy')}}</label>
                    </div>
                </div>
                <div class="col-12 lg:col-6 field" v-if="!isGas">
                    <label  :class="{'p-error':v$.data.environmentTemperature.$invalid && submitted}">{{$t('calculatorTankDevelopment.tempAmb')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="data.environmentTemperature" 
                        :minFractionDigits="2" :maxFractionDigits="2"/>
                        <div v-if="(v$.data.environmentTemperature.$invalid && submitted) || v$.data.environmentTemperature.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.environmentTemperature.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>
                <template v-if="isGas">
                    <div class="col-12 lg:col-6 field">
                        <label :class="{'p-error':v$.data.gasPressure.$invalid && submitted}">{{$t('calculatorTankDevelopment.gasPressure')}}</label>
                        <InputNumber class="w-full p-inputtext-sm"  v-model="data.gasPressure" 
                            :minFractionDigits="2" :maxFractionDigits="2"/>
                            <div v-if="(v$.data.gasPressure.$invalid && submitted) || v$.data.gasPressure.$pending.$response">
                                <small class="p-error" v-for="error in v$.data.gasPressure.$silentErrors" :key="error.$validator">
                                    {{$t(error.$message)}}
                                </small>
                            </div> 
                    </div>
                    <div class="col-12 lg:col-6 field">
                        <label :class="{'p-error':v$.data.gasTemperature.$invalid && submitted}">{{$t('calculatorTankDevelopment.gasTemperature')}}</label>
                        <InputNumber class="w-full p-inputtext-sm"  v-model="data.gasTemperature" 
                            :minFractionDigits="2" :maxFractionDigits="2"/>
                            <div v-if="(v$.data.gasTemperature.$invalid && submitted) || v$.data.gasTemperature.$pending.$response">
                                <small class="p-error" v-for="error in v$.data.gasTemperature.$silentErrors" :key="error.$validator">
                                    {{$t(error.$message)}}
                                </small>
                            </div> 
                    </div>
                    <div class="col-12 lg:col-6 field">
                        <label :class="{'p-error':v$.data.molecularWeight.$invalid && submitted}">{{$t('calculatorTankDevelopment.molecularWeight')}}</label>
                        <InputNumber class="w-full p-inputtext-sm"  v-model="data.molecularWeight" 
                            :minFractionDigits="2" :maxFractionDigits="2"/>
                            <div v-if="(v$.data.molecularWeight.$invalid && submitted) || v$.data.molecularWeight.$pending.$response">
                                <small class="p-error" v-for="error in v$.data.molecularWeight.$silentErrors" :key="error.$validator">
                                    {{$t(error.$message)}}
                                </small>
                            </div> 
                    </div>
                </template>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.tempCalib')}}</label>
                    <InputNumber class="w-full p-inputtext-sm"  v-model="data.calibrationTemperature" :minFractionDigits="2" :maxFractionDigits="2" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.temperature.$invalid && submitted}">{{$t('calculatorTankDevelopment.tempLiq')}}</label>
                    <InputNumber  mode="decimal" 
                        :minFractionDigits="2" :maxFractionDigits="2"
                        class="w-full p-inputtext-sm"  v-model="data.temperature" />
                        <div v-if="(v$.data.temperature.$invalid && submitted) || v$.data.temperature.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.temperature.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.density15.$invalid && submitted}">{{$t('calculatorTankDevelopment.density')}}</label>
                    <InputNumber  mode="decimal" 
                        :minFractionDigits="4" :maxFractionDigits="4"
                        class="w-full p-inputtext-sm" v-model="data.density15" />
                        <div v-if="(v$.data.density15.$invalid && submitted) || v$.data.density15.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.density15.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>
                <div class="col-12 lg:col-6 field" v-if="!isGas">
                    <label :class="{'p-error':v$.data.waterLevel.$invalid && submitted}">{{$t('calculatorTankDevelopment.levWater')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="data.waterLevel" />
                        <div v-if="(v$.data.waterLevel.$invalid && submitted) || v$.data.waterLevel.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.waterLevel.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>
                <div class="col-12 lg:col-6 field" v-if="movementCalculation">
                    <label>{{$t('calculatorTankDevelopment.movementType')}}</label>
                    <Dropdown class="w-full p-inputtext-sm" :placeholder="null" v-model="movementData.movementType" :options="movementTypes" optionValue="value">
                        <template #value="slotProps">
                        <div v-if="slotProps.value == 'I'">
                            <span>{{$t('calculatorTankDevelopment.introduction')}}</span>
                        </div>
                        <div v-else-if="slotProps.value == 'O'">
                            <span>{{$t('calculatorTankDevelopment.extraction')}}</span>
                        </div>
                        <div v-else>
                            <span class="p-dropdown-label"> </span>
                        </div>
                    </template>
                        <template #option="slotProps">
                            <div v-if="slotProps.option.value == 'I'">
                                <span>{{$t('calculatorTankDevelopment.introduction')}}</span>
                            </div>
                            <div v-else-if="slotProps.option.value == 'O'">
                                <span>{{$t('calculatorTankDevelopment.extraction')}}</span>
                            </div>
                        </template>
                    </Dropdown>
                </div>
                <div class="col-12 lg:col-6 field" v-if="movementCalculation">
                    <label>{{$t('tankOperations.movedWeight')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="movementData.simulationMovedWeight" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('tankOperations.managementType')}}</label>
                    <Dropdown
                        :class="{'p-inputtext-sm w-full': true}"
                        :placeholder="null" v-model="managementType" :options="managementTypesOptions" >
                    </Dropdown>
                </div>
            </div>
        </template>
        <template #footer>
            <Button :label="$t('calculatorDischargeDevelopment.calculate')" icon="pi pi-cog" class="m-2 p-button-sm" @click="submitCalculate(!v$.$invalid)" :disabled="!uiPermissions('tankCalculatorButton').isEnabled" />
            <!-- <Button :label="$t('cvtDeviation.btn.importFromPI')" icon="pi pi-upload" class="m-2 p-button-sm" @click="importFromPI" :disabled="!uiPermissions('tankCalculatorPIButton').isEnabled" /> -->
        </template>
    </Card>
</template>